
export default {
  mounted () {
    document.addEventListener('scroll', function () {
      var top = window.pageYOffset + window.innerHeight
      if (document.querySelector('#sustain') !== null) var sustain = top > document.querySelector('#sustain').offsetTop
      if (sustain) {
        document.getElementById('sustain').classList.add('fadeInUp')
      }
    })
  }
}
